<template>
  <el-dialog
      :model-value="props.visible"
      title="收货地址"
      width="850"
      destroy-on-close
      :close-on-click-modal="false"
      @open="onOpen"
      @closed="closedModal"
  >
    <div v-loading="pageLoading">
      <div style="padding: 30px 5px;">
        <info-label
            left-label="纳税人识别号"
            left-value="91320214323988856G"
            right-label="纳税人名称"
            :right-value="staticConfig.companyName"
        />
        <info-label
            left-label="银行营业网点"
            :left-value="staticConfig.companyName"
            right-label="三方协议号"
            right-value="02000 3308 0180 0065 5446"
        />
        <info-label
            left-label="银行行别"
            right-label="账号"
            right-value="02000 3308 0180 0065 5446"
        />
      </div>

      <div class="my-footer">
        <el-button type="primary"
                   size="large"
                   style="margin-left: 15px;" @click="onConfirm">确定
        </el-button>
        <el-button
            size="large"
            @click="emit('update:visible', false)">取消
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import InfoLabel from '@/components/InfoLabel'

const props = defineProps({
  visible: {
    type: Boolean,
    required: true
  },
  staticConfig: {
    type: Object,
    default: () => {}
  }
})

const pageLoading = ref(false)

function onOpen() {
}


const emit = defineEmits(['update:visible', 'onConfirm'])

function onConfirm() {
  emit('update:visible', false)
  emit('onConfirm')
}


function closedModal() {
  emit('update:visible', false)
}
</script>

<style scoped lang="scss">
.my-footer {
  display: flex;
  flex-direction: row-reverse;
  margin-top: 30px;
}
</style>
